import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export function methodsCarouselMobile() {
    document.addEventListener( 'DOMContentLoaded', function () {
        const blocks = document.querySelectorAll('.methods-carousel-mobile');
        if(blocks){
        blocks.forEach(block=>{
            new Splide(block, {
     
              perPage: 1,
              perMove: 1,
              autoplay: false,
              interval: 5500,
              pagination: false,
              arrows: true,
              breakpoints: {
                
                1100: {
                  perPage : 2,
                  perMove : 1,
                   arrows: true,
                },
                840: {
                  perPage : 1,
                  perMove : 1,
            
                }
              }
              }).mount();
        });
      }
    })
    
}